var render = function render(){var _vm=this,_c=_vm._self._c;return _c('youtube',{attrs:{"video-id":_vm.videoId,"player-width":_vm.width,"player-height":_vm.width / 16 * 9,"player-vars":_vm.playerVars,"mute":_vm.mute}})
}
var staticRenderFns = []

export { render, staticRenderFns }